import { AtmosphericDataEnum } from "@bienesis/common";
import {
  ChevronRight,
  CloudRainWind,
  Droplets,
  Sun,
  Thermometer,
  Wind,
} from "lucide-react";
import { useTranslation } from "react-i18next";

import { SelectableRow } from "../../components/SelectableRow";
import { SheetsEnum } from "../enums/sheets.enum";
import { SheetsType } from "../types/sheets.type";
import tw from "twin.macro";

type MeteorologicalVariable = {
  key: string;
  /** Variable atmosphérique — absente pour rainfall et les options « bientôt ». */
  atmosphericType?: AtmosphericDataEnum;
  isRainfall?: boolean;
  labelKey: string;
  icon: React.ReactNode;
  iconBg: string;
  iconColor: string;
  available: boolean;
};

const OPTIONS: MeteorologicalVariable[] = [
  {
    key: "rainfall",
    isRainfall: true,
    labelKey: "meteo.climateHistory.rainfall",
    icon: <CloudRainWind css={tw`w-5 h-5`} />,
    iconBg: "#FFFFFF",
    iconColor: "#3B82F6",
    available: true,
  },
  {
    key: "solarIrradiance",
    atmosphericType: AtmosphericDataEnum.IRRADIANCE,
    labelKey: "meteo.climateHistory.solarIrradiance",
    icon: <Sun css={tw`w-5 h-5`} />,
    iconBg: "#FFFFFF",
    iconColor: "#F59E0B",
    available: true,
  },
  {
    key: "temperatures",
    atmosphericType: AtmosphericDataEnum.TEMPERATURE,
    labelKey: "meteo.climateHistory.temperatures",
    icon: <Thermometer css={tw`w-5 h-5`} />,
    iconBg: "#FFFFFF",
    iconColor: "#F87171",
    available: true,
  },
  {
    key: "humidity",
    atmosphericType: AtmosphericDataEnum.HUMIDITY,
    labelKey: "meteo.climateHistory.humidity",
    icon: <Droplets css={tw`w-5 h-5`} />,
    iconBg: "#FFFFFF",
    iconColor: "#22D3EE",
    available: true,
  },
  {
    key: "wind",
    atmosphericType: AtmosphericDataEnum.WIND,
    labelKey: "meteo.climateHistory.wind",
    icon: <Wind css={tw`w-5 h-5`} />,
    iconBg: "#FFFFFF",
    iconColor: "#94A3B8",
    available: true,
  },
];

export default function ClimateHistoryChoiceSheetBody({
  pushSheet,
}: {
  pushSheet: (view: SheetsType) => void;
}) {
  const { t } = useTranslation();

  return (
    <div css={tw`flex flex-col px-4 pb-6`}>
      <div css={tw`rounded-xl border overflow-hidden`}>
        {OPTIONS.map((opt, i) => (
          <SelectableRow
            available={opt.available}
            key={opt.key}
            icon={opt.icon}
            iconBg={opt.iconBg}
            iconColor={opt.iconColor}
            label={t(opt.labelKey as never)}
            active={opt.available}
            highlightActive={false}
            isLast={i === OPTIONS.length - 1}
            trailing={
              <ChevronRight css={tw`w-4 h-4 text-green-800 shrink-0`} />
            }
            onClick={() => {
              if (opt.isRainfall) {
                pushSheet({
                  id: SheetsEnum.CLIMATE_RAINFALL_VIEW,
                  canGoBack: true,
                });
              } else if (opt.atmosphericType) {
                pushSheet({
                  id: SheetsEnum.CLIMATE_ATMOSPHERIC_VIEW,
                  canGoBack: true,
                  type: opt.atmosphericType,
                });
              }
            }}
          />
        ))}
      </div>
    </div>
  );
}
